"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// "1637323" or 1637323 -> "$1,637,323.00"
// "78789.76888" -> "$78,789.77"
const DollarsCentsFormatter = new Intl.NumberFormat("en", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
exports.DollarsCentsFormatter = DollarsCentsFormatter;
// "1637323" or 1637323 -> "$1,637,323"
// "78789.76888" -> "$78,790"
const DollarsOnlyFormatter = new Intl.NumberFormat("en", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
exports.DollarsOnlyFormatter = DollarsOnlyFormatter;
const formatMoney = DollarsCentsFormatter.format;
exports.formatMoney = formatMoney;
